import { Button as MuiButton, ButtonProps } from '@mui/material';
import classNames from 'classnames';

export type ButtonType = 'primary' | 'outlined' | 'primaryOutlined' | 'danger' | 'dangerOutlined';

type UiKitButtonProps = Omit<ButtonProps, 'color' | 'variant'> & {
  buttonType: ButtonType;
  size?: 'small' | 'medium' | 'large';
};

const buttonTypeProps: Record<ButtonType, Pick<ButtonProps, 'variant' | 'color'>> = {
  primary: { variant: 'contained', color: 'primary' },
  outlined: { variant: 'outlined', color: 'outlinePrimary' as ButtonProps['color'] },
  primaryOutlined: { variant: 'outlined', color: 'primary' },
  danger: { variant: 'contained', color: 'error' },
  dangerOutlined: { variant: 'outlined', color: 'error' },
};

const Button = ({ buttonType, size, fullWidth, ...props }: UiKitButtonProps) => (
  <MuiButton
    {...buttonTypeProps[buttonType]}
    {...props}
    className={classNames('ui-kit-button', size && `ui-kit-button--${size}`, props.className)}
    fullWidth={fullWidth}
  >
    {props.children}
  </MuiButton>
);

export default Button;
